var utilsPlugIn = {};
import {formatMessage, locale, loadMessages} from "devextreme/localization";
import Dictionary from "@/dictionary.js";
import {SysConfig, PageConfig, CommonCode} from "@/env/SysConfig.js";

String.prototype.format = function() {
  let args = arguments;
  return this.replace(/{(\d+)}/g, function(match, num) {
    num = Number(num) + 1;
    return typeof args[num - 1] != undefined ? args[num - 1] : match;
  });
};

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.addMonths = function(months) {
  var date = new Date(this.valueOf());
  date.setMonth(date.getMonth() + months);
  return date;
};

Date.prototype.format = function(f) {
  if (!this.valueOf()) return " ";

  var weekName = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
  var d = this;

  return f.replace(/(yyyy|yy|MM|dd|E|hh|mm|ss|a\/p)/gi, function($1) {
    switch ($1) {
      case "yyyy":
        return d.getFullYear();
      case "yy":
        return (d.getFullYear() % 1000).zf(2);
      case "MM":
        return (d.getMonth() + 1).zf(2);
      case "dd":
        return d.getDate().zf(2);
      case "E":
        return weekName[d.getDay()];
      case "HH":
        return d.getHours().zf(2);
      case "hh":
        return ((h = d.getHours() % 12) ? h : 12).zf(2);
      case "mm":
        return d.getMinutes().zf(2);
      case "ss":
        return d.getSeconds().zf(2);
      case "a/p":
        return d.getHours() < 12 ? "오전" : "오후";
      default:
        return $1;
    }
  });
};

String.prototype.string = function(len) {
  var s = "",
    i = 0;
  while (i++ < len) {
    s += this;
  }
  return s;
};
String.prototype.zf = function(len) {
  return "0".string(len - this.length) + this;
};
Number.prototype.zf = function(len) {
  return this.toString().zf(len);
};

Array.prototype.remove = function(str) {
  const idx = this.findIndex(function(item) {
    return item === str;
  });

  if (idx > -1) this.splice(idx, 1);
};

utilsPlugIn.install = function(Vue, options) {
  var UserLib = {
    locale: null,
    locales: null,
    EMPTY_STR: "",
    CommonCode: CommonCode,
    SysConfig: SysConfig,

    log(str) {
      //-- console.log(str);
    },
    //객체 복사
    fnObjCopy(obj) {
      var copy = {};
      if (Array.isArray(obj)) {
        copy = obj.slice().map((v) => {
          return this.fnObjCopy(v);
        });
      } else if (typeof obj === "object" && obj !== null) {
        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            copy[attr] = this.fnObjCopy(obj[attr]);
          }
        }
      } else {
        copy = obj;
      }
      return copy;
    },

    //객체 복사
    fnCopyObj(s, t) {
      if (null == s || "object" != typeof s) return;

      for (var attr in t) {
        s[attr] = t[attr];
      }
      return s;
    },

    //번역
    fnMessage(str) {
      try {
        let sMsg = formatMessage(str);
        if (sMsg === "") {
          sMsg = str;
        }
        return sMsg;
      } catch (error) {
        //-- console.log(error);
      }
      return str;
    },

    //현재 로케일
    fnGetLocale() {
      const locale = localStorage.getItem("locale");
      this.locale = locale;
      return this.locale != null ? this.locale : "ko";
    },

    //로케일변경
    fnSetLocale(locale) {
      localStorage.setItem("locale", locale);
    },

    //로케일 초기화
    fnInitGlobalize() {
      this.locales = Dictionary.getLocales();
      loadMessages(Dictionary.getDictionary());
      this.locale = localStorage.getItem("locale");
      this.locale != null ? this.locale : "ko";

      locale(this.locale);
      return this.locales;
    },

    //언어변경
    fnChangeLocale(value) {
      this.fnSetLocale(value);
      document.location.reload();
    },

    //객체 복사
    fnRowApply(s, t) {
      if (null == s || "object" != typeof s) return;

      for (var attr in s) {
        if (t.hasOwnProperty(attr)) {
          s[attr] = t[attr];
        }
      }
      return;
    },

    //객체 배열 복사
    fnRowArrayApply(s, t) {
      for (let index = 0; index < s.length; index++) {
        this.fnRowApply(s[index], t[index]);
      }
    },

    /**
     * [문자열처리]
     * ex) 문자열값이 있는지 체크  : this.UserLib.fnStrIsNotEmpty(username)
     * @param {string} value
     * @returns boolean
     */
    fnStrIsNotEmpty(value) {
      return value !== undefined && value !== null && value !== this.EMPTY_STR;
    },
    /**
     * [문자열처리]
     * ex) null 또는 빈값 체크  : this.UserLib.fnStrIsEmpty(username)
     * @param {string} value
     * @returns boolean
     */
    fnStrIsEmpty(value) {
      return !this.fnStrIsNotEmpty(value);
    },
    fnIsNotEmpty(value) {
      return value !== undefined && value !== null;
    },
    fnIsEmpty(obj) {
      return !this.fnIsNotEmpty(obj);
    },
    /**
     * [문자열처리]
     * ex) null 이던 관계없이 문자열 길이 체크하기 : strings.length(username)
     * @param {string} value
     * @returns int
     */
    fnStrLength(value) {
      return this.fnStrIsEmpty(value) ? value.length : 0;
    },
    /**
     * [문자열처리]
     * ex) null일경우, 빈공백으로 대체하기  : strings.nvl(username)
     * ex) null일경우, 특정문자열로 대체하기  : strings.nvl(username,'guest')
     * @param {string} value
     * @param {string} replaceStr
     * @returns string
     */
    fnStrNvl: function(value, replaceStr = undefined) {
      return this.fnStrIsEmpty(value) ? (this.fnStrIsEmpty(replaceStr) ? this.EMPTY_STR : replaceStr) : value;
    },
    fnObjNvl: function(value, replaceObj = undefined) {
      return value ? value : replaceObj;
    },
    /**
     * 화면에서 선택자에 해당하는 영역이 보이는지 여부
     * @param {string} selector
     * @returns boolean
     */
    fnIsShow: function(selector) {
      var listObj = document.querySelector(selector);
      return listObj.style.display !== "none";
    },
    fnShow: function(selector) {
      var listObj = document.querySelector(selector);
      listObj.style.display = "";
    },
    fnHide: function(selector) {
      var listObj = document.querySelector(selector);
      listObj.style.display = "none";
    },

    //업무함수 Start ------------------------------------------------------------------------------------------------------------------

    //내림차순 정렬
    fnAscSort: function(a, b) {
      if (a.sequenceNumber > b.sequenceNumber) {
        return 1;
      }
      if (a.sequenceNumber < b.sequenceNumber) {
        return -1;
      }
      // a must be equal to b
      return 0;
    },

    //공통코드 GroupCode로 가져오기
    fnGetCommonCodes: function(sGroupCode) {
      let resultArray = [];
      let arr = this.CommonCode.commonDetail.filter((obj) => obj.groupCode == sGroupCode);

      arr.sort(this.fnAscSort);
      arr.forEach((obj) => {
        if (obj.groupCode == sGroupCode) resultArray.push(obj.detailCodeName);
      });

      return resultArray;
    },

    //공통코드 GroupCode로 해쉬맵으로 가져오기
    fnGetCommonCodesKeyValue: function(sGroupCode, keyExpr, valueExpr) {
      let resultArray = [];
      let arr = this.CommonCode.commonDetail.filter((obj) => obj.groupCode == sGroupCode);

      arr.sort(this.fnAscSort);
      arr.forEach((obj) => {
        resultArray.push({key: obj[keyExpr], value: obj[valueExpr]});
      });

      return resultArray;
    },

    //업무함수 End ------------------------------------------------------------------------------------------------------------------
  };
  Vue.prototype.UserLib = UserLib;
  Vue.prototype.fm = UserLib.fnMessage;
};

export default utilsPlugIn;
